// @generated by bzl gen
// @generated by protoc-gen-es v0.2.1 with parameter "target=ts"
// @generated from file dropbox/proto/context_engine/assist_compose.proto (package context_engine, syntax proto3)
/* eslint-disable */
/* @ts-nocheck */

import type {
  BinaryReadOptions,
  FieldList,
  JsonReadOptions,
  JsonValue,
  PartialMessage,
  PlainMessage,
} from "@bufbuild/protobuf";
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { ChatMessage } from "./ml_capabilities_common_clone_pb";

/**
 * @generated from enum context_engine.SourceContentType
 */
export enum SourceContentType {
  /**
   * @generated from enum value: DASH_SEARCH_RESULT = 0;
   */
  DASH_SEARCH_RESULT = 0,

  /**
   * @generated from enum value: RECOMMENDATION = 1;
   */
  RECOMMENDATION = 1,

  /**
   * @generated from enum value: TRANSIENT = 2;
   */
  TRANSIENT = 2,

  /**
   * @generated from enum value: LOCAL_FILE_CONTENT = 3;
   */
  LOCAL_FILE_CONTENT = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(SourceContentType)
proto3.util.setEnumType(SourceContentType, "context_engine.SourceContentType", [
  { no: 0, name: "DASH_SEARCH_RESULT" },
  { no: 1, name: "RECOMMENDATION" },
  { no: 2, name: "TRANSIENT" },
  { no: 3, name: "LOCAL_FILE_CONTENT" },
]);

/**
 * @generated from enum context_engine.AssistCustomMode
 */
export enum AssistCustomMode {
  /**
   * @generated from enum value: ONBOARDING = 0;
   */
  ONBOARDING = 0,
}
// Retrieve enum metadata with: proto3.getEnumType(AssistCustomMode)
proto3.util.setEnumType(AssistCustomMode, "context_engine.AssistCustomMode", [
  { no: 0, name: "ONBOARDING" },
]);

/**
 * @generated from enum context_engine.AssistUserDataAccessType
 */
export enum AssistUserDataAccessType {
  /**
   * @generated from enum value: INDIVIDUAL = 0;
   */
  INDIVIDUAL = 0,

  /**
   * Shared to users with same team id (share to company)
   *
   * @generated from enum value: TEAM = 1;
   */
  TEAM = 1,
}
// Retrieve enum metadata with: proto3.getEnumType(AssistUserDataAccessType)
proto3.util.setEnumType(
  AssistUserDataAccessType,
  "context_engine.AssistUserDataAccessType",
  [
    { no: 0, name: "INDIVIDUAL" },
    { no: 1, name: "TEAM" },
  ],
);

/**
 * @generated from message context_engine.SourceContent
 */
export class SourceContent extends Message<SourceContent> {
  /**
   * @generated from field: string state = 1;
   */
  state = "";

  /**
   * @generated from field: string uuid = 2;
   */
  uuid = "";

  /**
   * @generated from field: string title = 3;
   */
  title = "";

  /**
   * @generated from field: string url = 4;
   */
  url = "";

  /**
   * Optional truncated source body
   *
   * @generated from field: string content = 5;
   */
  content = "";

  /**
   * Defaults to DASH_SEARCH_RESULT (0) if not set.
   *
   * @generated from field: context_engine.SourceContentType type = 6;
   */
  type = SourceContentType.DASH_SEARCH_RESULT;

  constructor(data?: PartialMessage<SourceContent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.SourceContent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "state", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "uuid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    {
      no: 6,
      name: "type",
      kind: "enum",
      T: proto3.getEnumType(SourceContentType),
    },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): SourceContent {
    return new SourceContent().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): SourceContent {
    return new SourceContent().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): SourceContent {
    return new SourceContent().fromJsonString(jsonString, options);
  }

  static equals(
    a: SourceContent | PlainMessage<SourceContent> | undefined,
    b: SourceContent | PlainMessage<SourceContent> | undefined,
  ): boolean {
    return proto3.util.equals(SourceContent, a, b);
  }
}

/**
 * @generated from message context_engine.ComposeParams
 */
export class ComposeParams extends Message<ComposeParams> {
  /**
   * @generated from field: string markdown_content = 1;
   */
  markdownContent = "";

  /**
   * @generated from field: bool must_generate_draft = 2;
   */
  mustGenerateDraft = false;

  /**
   * @generated from field: string voice_id = 3;
   */
  voiceId = "";

  /**
   * TODO (will) deprecate in OTCA-288
   *
   * @generated from field: repeated context_engine.SourceContent voice_sources = 4;
   */
  voiceSources: SourceContent[] = [];

  /**
   * TODO (will) deprecate in OTCA-288
   *
   * @generated from field: repeated string voice_modification_history = 5;
   */
  voiceModificationHistory: string[] = [];

  /**
   * @generated from field: string template_id = 6;
   */
  templateId = "";

  /**
   * TODO (will) deprecate in OTCA-288
   *
   * @generated from field: repeated context_engine.SourceContent template_sources = 7;
   */
  templateSources: SourceContent[] = [];

  /**
   * TODO (will) deprecate in OTCA-288
   *
   * @generated from field: repeated string template_modification_history = 8;
   */
  templateModificationHistory: string[] = [];

  /**
   * @generated from field: repeated string custom_voice_samples = 9;
   */
  customVoiceSamples: string[] = [];

  /**
   * @generated from field: string custom_template_content = 10;
   */
  customTemplateContent = "";

  constructor(data?: PartialMessage<ComposeParams>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.ComposeParams";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "markdown_content",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
    },
    {
      no: 2,
      name: "must_generate_draft",
      kind: "scalar",
      T: 8 /* ScalarType.BOOL */,
    },
    { no: 3, name: "voice_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    {
      no: 4,
      name: "voice_sources",
      kind: "message",
      T: SourceContent,
      repeated: true,
    },
    {
      no: 5,
      name: "voice_modification_history",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
      repeated: true,
    },
    {
      no: 6,
      name: "template_id",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
    },
    {
      no: 7,
      name: "template_sources",
      kind: "message",
      T: SourceContent,
      repeated: true,
    },
    {
      no: 8,
      name: "template_modification_history",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
      repeated: true,
    },
    {
      no: 9,
      name: "custom_voice_samples",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
      repeated: true,
    },
    {
      no: 10,
      name: "custom_template_content",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
    },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): ComposeParams {
    return new ComposeParams().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): ComposeParams {
    return new ComposeParams().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): ComposeParams {
    return new ComposeParams().fromJsonString(jsonString, options);
  }

  static equals(
    a: ComposeParams | PlainMessage<ComposeParams> | undefined,
    b: ComposeParams | PlainMessage<ComposeParams> | undefined,
  ): boolean {
    return proto3.util.equals(ComposeParams, a, b);
  }
}

/**
 * @generated from message context_engine.ModifyVoiceParams
 */
export class ModifyVoiceParams extends Message<ModifyVoiceParams> {
  /**
   * @generated from field: string voice_id = 1;
   */
  voiceId = "";

  /**
   * @generated from field: repeated context_engine.VoiceSample voice_samples = 2;
   */
  voiceSamples: VoiceSample[] = [];

  /**
   * @generated from field: repeated string voice_modification_history = 3;
   */
  voiceModificationHistory: string[] = [];

  /**
   * @generated from field: repeated context_engine.SourceContent voice_sources = 4;
   */
  voiceSources: SourceContent[] = [];

  constructor(data?: PartialMessage<ModifyVoiceParams>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.ModifyVoiceParams";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "voice_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    {
      no: 2,
      name: "voice_samples",
      kind: "message",
      T: VoiceSample,
      repeated: true,
    },
    {
      no: 3,
      name: "voice_modification_history",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
      repeated: true,
    },
    {
      no: 4,
      name: "voice_sources",
      kind: "message",
      T: SourceContent,
      repeated: true,
    },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): ModifyVoiceParams {
    return new ModifyVoiceParams().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): ModifyVoiceParams {
    return new ModifyVoiceParams().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): ModifyVoiceParams {
    return new ModifyVoiceParams().fromJsonString(jsonString, options);
  }

  static equals(
    a: ModifyVoiceParams | PlainMessage<ModifyVoiceParams> | undefined,
    b: ModifyVoiceParams | PlainMessage<ModifyVoiceParams> | undefined,
  ): boolean {
    return proto3.util.equals(ModifyVoiceParams, a, b);
  }
}

/**
 * @generated from message context_engine.VoiceSample
 */
export class VoiceSample extends Message<VoiceSample> {
  /**
   * @generated from field: string content_type = 1;
   */
  contentType = "";

  /**
   * @generated from field: string text = 2;
   */
  text = "";

  constructor(data?: PartialMessage<VoiceSample>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.VoiceSample";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "content_type",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
    },
    { no: 2, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): VoiceSample {
    return new VoiceSample().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): VoiceSample {
    return new VoiceSample().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): VoiceSample {
    return new VoiceSample().fromJsonString(jsonString, options);
  }

  static equals(
    a: VoiceSample | PlainMessage<VoiceSample> | undefined,
    b: VoiceSample | PlainMessage<VoiceSample> | undefined,
  ): boolean {
    return proto3.util.equals(VoiceSample, a, b);
  }
}

/**
 * @generated from message context_engine.VoiceRedraftedSample
 */
export class VoiceRedraftedSample extends Message<VoiceRedraftedSample> {
  /**
   * @generated from field: string content_type = 1;
   */
  contentType = "";

  /**
   * @generated from field: string text = 2;
   */
  text = "";

  constructor(data?: PartialMessage<VoiceRedraftedSample>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.VoiceRedraftedSample";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "content_type",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
    },
    { no: 2, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): VoiceRedraftedSample {
    return new VoiceRedraftedSample().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): VoiceRedraftedSample {
    return new VoiceRedraftedSample().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): VoiceRedraftedSample {
    return new VoiceRedraftedSample().fromJsonString(jsonString, options);
  }

  static equals(
    a: VoiceRedraftedSample | PlainMessage<VoiceRedraftedSample> | undefined,
    b: VoiceRedraftedSample | PlainMessage<VoiceRedraftedSample> | undefined,
  ): boolean {
    return proto3.util.equals(VoiceRedraftedSample, a, b);
  }
}

/**
 * @generated from message context_engine.AssistantCustomModeParams
 */
export class AssistantCustomModeParams extends Message<AssistantCustomModeParams> {
  /**
   * @generated from field: context_engine.AssistCustomMode custom_mode = 1;
   */
  customMode = AssistCustomMode.ONBOARDING;

  constructor(data?: PartialMessage<AssistantCustomModeParams>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.AssistantCustomModeParams";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "custom_mode",
      kind: "enum",
      T: proto3.getEnumType(AssistCustomMode),
    },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): AssistantCustomModeParams {
    return new AssistantCustomModeParams().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): AssistantCustomModeParams {
    return new AssistantCustomModeParams().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): AssistantCustomModeParams {
    return new AssistantCustomModeParams().fromJsonString(jsonString, options);
  }

  static equals(
    a:
      | AssistantCustomModeParams
      | PlainMessage<AssistantCustomModeParams>
      | undefined,
    b:
      | AssistantCustomModeParams
      | PlainMessage<AssistantCustomModeParams>
      | undefined,
  ): boolean {
    return proto3.util.equals(AssistantCustomModeParams, a, b);
  }
}

/**
 * @generated from message context_engine.AssistChatParams
 */
export class AssistChatParams extends Message<AssistChatParams> {
  /**
   * @generated from field: repeated context_engine.ChatMessage history = 1;
   */
  history: ChatMessage[] = [];

  /**
   * @generated from field: context_engine.ChatMessage new_message = 2;
   */
  newMessage?: ChatMessage;

  /**
   * @generated from field: context_engine.ComposeParams compose_params = 3;
   */
  composeParams?: ComposeParams;

  /**
   * @generated from field: bool include_source_content = 4;
   */
  includeSourceContent = false;

  /**
   * @generated from field: repeated context_engine.SourceContent sources = 5;
   */
  sources: SourceContent[] = [];

  /**
   * @generated from field: repeated context_engine.ChatMessage tool_messages = 6;
   */
  toolMessages: ChatMessage[] = [];

  /**
   * @generated from field: bool dash_search_enabled = 7;
   */
  dashSearchEnabled = false;

  /**
   * @generated from field: context_engine.ModifyVoiceParams modify_voice_params = 8;
   */
  modifyVoiceParams?: ModifyVoiceParams;

  /**
   * @generated from field: context_engine.AssistantCustomModeParams custom_mode_params = 9;
   */
  customModeParams?: AssistantCustomModeParams;

  constructor(data?: PartialMessage<AssistChatParams>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.AssistChatParams";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "history", kind: "message", T: ChatMessage, repeated: true },
    { no: 2, name: "new_message", kind: "message", T: ChatMessage },
    { no: 3, name: "compose_params", kind: "message", T: ComposeParams },
    {
      no: 4,
      name: "include_source_content",
      kind: "scalar",
      T: 8 /* ScalarType.BOOL */,
    },
    {
      no: 5,
      name: "sources",
      kind: "message",
      T: SourceContent,
      repeated: true,
    },
    {
      no: 6,
      name: "tool_messages",
      kind: "message",
      T: ChatMessage,
      repeated: true,
    },
    {
      no: 7,
      name: "dash_search_enabled",
      kind: "scalar",
      T: 8 /* ScalarType.BOOL */,
    },
    {
      no: 8,
      name: "modify_voice_params",
      kind: "message",
      T: ModifyVoiceParams,
    },
    {
      no: 9,
      name: "custom_mode_params",
      kind: "message",
      T: AssistantCustomModeParams,
    },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): AssistChatParams {
    return new AssistChatParams().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): AssistChatParams {
    return new AssistChatParams().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): AssistChatParams {
    return new AssistChatParams().fromJsonString(jsonString, options);
  }

  static equals(
    a: AssistChatParams | PlainMessage<AssistChatParams> | undefined,
    b: AssistChatParams | PlainMessage<AssistChatParams> | undefined,
  ): boolean {
    return proto3.util.equals(AssistChatParams, a, b);
  }
}

/**
 * @generated from message context_engine.AssistUserDataItem
 */
export class AssistUserDataItem extends Message<AssistUserDataItem> {
  /**
   * @generated from field: string user_data_type = 1;
   */
  userDataType = "";

  /**
   * @generated from field: string user_data_key = 2;
   */
  userDataKey = "";

  /**
   * @generated from field: string user_data = 3;
   */
  userData = "";

  /**
   * Added revision number to track changes to user data items.
   *
   * @generated from field: uint64 rev = 4;
   */
  rev = protoInt64.zero;

  /**
   * Defaults to INDIVIDUAL (0) if not set.
   *
   * @generated from field: context_engine.AssistUserDataAccessType access_type = 5;
   */
  accessType = AssistUserDataAccessType.INDIVIDUAL;

  /**
   * @generated from field: bool is_owned = 6;
   */
  isOwned = false;

  constructor(data?: PartialMessage<AssistUserDataItem>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.AssistUserDataItem";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "user_data_type",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
    },
    {
      no: 2,
      name: "user_data_key",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
    },
    { no: 3, name: "user_data", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "rev", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    {
      no: 5,
      name: "access_type",
      kind: "enum",
      T: proto3.getEnumType(AssistUserDataAccessType),
    },
    { no: 6, name: "is_owned", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): AssistUserDataItem {
    return new AssistUserDataItem().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): AssistUserDataItem {
    return new AssistUserDataItem().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): AssistUserDataItem {
    return new AssistUserDataItem().fromJsonString(jsonString, options);
  }

  static equals(
    a: AssistUserDataItem | PlainMessage<AssistUserDataItem> | undefined,
    b: AssistUserDataItem | PlainMessage<AssistUserDataItem> | undefined,
  ): boolean {
    return proto3.util.equals(AssistUserDataItem, a, b);
  }
}
